import request from "@/utils/request";

// 运营商保存企业收款用户信息
export default function agentFillEnterPriseInfo(data) {
  return request({
    url: `/user/agent/agent/fillEnterPriseInfo`,
    method: "post",
    data,
  });
}
